import { Injectable } from '@angular/core';

import {
    FieldTypes
} from 'axilla-shared-dto';

import * as moment from 'moment';

@Injectable()
export class TypeHelperService {


    constructor( ) { }


    getFieldType(field: any): number {
        const type = typeof field;

        if (field instanceof Date || moment.isMoment(field)) {
            return FieldTypes.Date;
        }

        switch (type) {
            case 'number':
                return FieldTypes.Number;
            case 'string':
                return FieldTypes.Text;
            default:
                return FieldTypes.Text;
        }
    }
}
